import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { AuthRoles } from '../models'
import { authService } from '../services'
import { authActions } from '../store/actions'

const useAuth = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(authActions.getUserCurrentStorage())
  }, [dispatch])

  const userCurrent = useSelector((state: any) => state.userCurrentStorage ? state.userCurrentStorage : {})

  const getInfo = () => {
    const { info } = userCurrent
    return info
  }

  const getUserFullName = (): string => {
    const userInfo = getInfo()
    return `${userInfo.first_name} ${userInfo.last_name}`
  }

  const getId = () => {
    const userInfo = getInfo()
    return userInfo.id
  }

  const getWelcome = () => {
    const userInfo = getInfo()
    const { gender_id } = userInfo

    if(gender_id === 1) {
      return 'Bienvenida'
    } if(gender_id === 2) {
      return 'Bienvenido'
    } else {
      return 'Bienvenid@'
    }
  }

  const isUserSessionExpired = () => {
    return authService.isUserSessionExpired()
  }

  const setUserSessionExpired = (expireSw: boolean = false) => {
    authService.setUserCurrentSessionExpired(expireSw)
  }

  const isLoggedIn = (role: AuthRoles = '') => {
    return authService.isLoggedIn(role)
  }

  const logout = () => {
    dispatch(authActions.logout(getId()))
  }

  return {
    userCurrent,
    getId,
    getUserFullName,
    getInfo,
    getWelcome,
    isLoggedIn,
    isUserSessionExpired,
    setUserSessionExpired,
    logout
  }
}

export { useAuth }